import React from "react"
import { IsOnTrack } from "../../App"

export default function EmailSupport() {
  return (
    <span>Need help? Email&nbsp;
      {location.host.includes("ontrack")  && <a href="mailto:ontracksupport@crlcorp.com">ontracksupport@crlcorp.com</a>}
      {!location.host.includes("ontrack")  && <a href="mailto:workforcesupport@crlcorp.com">workforcesupport@crlcorp.com</a>}
    </span>
  )
}
